import { PaginationState } from '../types/state';

export const createPaginationAdapter = <SliceState>({
  selectState,
}: {
  selectState: (state: SliceState) => PaginationState;
}) => ({
  reset: (sliceState: SliceState) => {
    const state = selectState(sliceState);
    state.page = 0;
  },
  setPage: (sliceState: SliceState, { payload: page }: { payload: number }) => {
    const state = selectState(sliceState);
    state.page = page;
  },
  setPageSize: (sliceState: SliceState, { payload: pageSize }: { payload: number }) => {
    const state = selectState(sliceState);
    state.page = Math.floor((state.page * state.pageSize) / pageSize);
    state.pageSize = pageSize;
  },
});
